import { Directive, ElementRef, inject } from '@angular/core';
import { selectorCoreInstanceInfo } from '@bepatient/core';
import { CommonUtilsService } from '../services/common-utils.service';

@Directive({
  selector: '[bpApplyInstanceColor]',
  standalone: false
})
export class ApplyInstanceColorDirective {
  constructor() {
    const el = inject(ElementRef);
    const commonUtils = inject(CommonUtilsService);

    commonUtils
      .storeSelectOne(selectorCoreInstanceInfo, true)
      .then(instance => (el.nativeElement.style.color = instance.appColor));
  }
}
